import { gql } from '@apollo/client';

export const ALL_INTERVENTION_FOCUS = gql`
  query AllInterventionFocus($interventionTypeId: ID) {
    getInterventionFocus(interventionTypeId: $interventionTypeId) {
      id
      name
    }
  }
`;
